export type ShapeTextPreset = 'heading' | 'subheading' | 'body';

/** Giá trị khối shapeText (trừ id) — dùng cho rail « Văn bản » và menu Thêm phần tử */
export function shapeTextPresetFields(preset: ShapeTextPreset) {
  switch (preset) {
    case 'heading':
      return {
        type: 'shapeText' as const,
        x: 8,
        y: 12,
        w: 84,
        h: 14,
        text: 'Tiêu đề',
        shape: 'rounded' as const,
        style: {
          fontSize: 34,
          fontWeight: 700,
          color: '#ffffff',
          textAlign: 'center' as const,
          backgroundColor: 'rgba(255,255,255,0.08)',
          padding: 16,
          fontFamily: "'Playfair Display', serif",
        },
      };
    case 'subheading':
      return {
        type: 'shapeText' as const,
        x: 10,
        y: 26,
        w: 80,
        h: 12,
        text: 'Tiêu đề phụ',
        shape: 'rounded' as const,
        style: {
          fontSize: 22,
          fontWeight: 600,
          color: '#e2e8f0',
          textAlign: 'center' as const,
          backgroundColor: 'rgba(255,255,255,0.06)',
          padding: 14,
          fontFamily: "'Montserrat', sans-serif",
        },
      };
    case 'body':
    default:
      return {
        type: 'shapeText' as const,
        x: 10,
        y: 40,
        w: 78,
        h: 22,
        text: 'Thêm nội dung văn bản',
        shape: 'rounded' as const,
        style: {
          fontSize: 16,
          fontWeight: 400,
          color: '#cbd5e1',
          textAlign: 'left' as const,
          backgroundColor: 'rgba(255,255,255,0.05)',
          padding: 12,
          fontFamily: "'Be Vietnam Pro', sans-serif",
        },
      };
  }
}
